export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Est-ce un produit physique ?',
    answer:
      'Non. DIAGNOSTIC AUTOMOBILE PRO™ est un système 100 % numérique au format PDF, lisible sur ordinateur, tablette ou téléphone, et imprimable pour l’atelier.',
  },
  {
    question: 'À qui s’adresse-t-il ?',
    answer:
      'Aux mécaniciens et techniciens d’atelier (garages indépendants, concessions, centres auto), aux apprentis et élèves en CAP et Bac Pro Maintenance des véhicules, aux étudiants en BTS Maintenance des véhicules, ainsi qu’aux mécaniciens autodidactes et aux passionnés.',
  },
  {
    question: 'Faut-il déjà savoir diagnostiquer ?',
    answer:
      'Non. Le module 6 pose la méthode de l’atelier étape par étape et chaque module l’applique : SYMPTÔME › CODES › MESURES › HYPOTHÈSE › VALIDATION.',
  },
  {
    question: 'Est-ce un cours théorique ?',
    answer:
      'Non. C’est un système de consultation prêt à l’emploi : fiches de diagnostic, arbres de décision, tableaux de contrôle, procédures pas à pas, checklists atelier et cas pratiques.',
  },
  {
    question: 'Faut-il un scanner ou un outil particulier ?',
    answer:
      'Un lecteur de codes OBD-II et un multimètre suffisent pour appliquer la plupart des procédures. Le système ne recommande aucune marque d’outil.',
  },
  {
    question: 'Les valeurs de référence sont-elles propres à un modèle ?',
    answer:
      'Non. Les valeurs données sont indicatives et toujours accompagnées de la mention « selon les données constructeur ». Aucun couple de serrage ni valeur propre à un modèle précis : la documentation du constructeur reste la référence.',
  },
  {
    question: 'Les cas pratiques sont-ils réels ?',
    answer:
      'Non. Ce sont des cas pédagogiques fictifs, sans référence à un véhicule ou à une marque, résolus pas à pas pour entraîner le raisonnement.',
  },
  {
    question: 'Que contiennent les 5 bonus ?',
    answer:
      'Guide des codes défaut OBD-II, guide pratique du multimètre, fiches atelier imprimables, guide des voyants du tableau de bord et cahier de 50 cas pratiques analysés pas à pas.',
  },
  {
    question: 'Est-ce une certification ou une formation qualifiante ?',
    answer:
      'Non. C’est un support technique et pédagogique. Il ne remplace ni la documentation constructeur, ni la formation, ni les règles de sécurité de l’atelier.',
  },
  {
    question: 'Comment vais-je recevoir le produit ?',
    answer: 'Vous recevez l’accès numérique immédiatement après l’achat, par e-mail.',
  },
]
